module.exports = __webpack_public_path__ + "static/media/asm.555d5098.png";